import { useUserInfo } from './useUserInfo';
export const useCurrentUser = () => {
  const userInfo = useUserInfo();
  return userInfo === null || userInfo === void 0 ? void 0 : userInfo.user;
};